import { render } from "./FilterableNumber.vue?vue&type=template&id=4ca0247a"
import script from "./FilterableNumber.vue?vue&type=script&lang=js"
export * from "./FilterableNumber.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__